module.exports = __webpack_public_path__ + "static/vas.d0ffb755.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/partners/vas.png
// module id = 1622
// module chunks = 35783957827783